import type {
  GetProcessorInstanceQuery,
  GetProcessorInstanceQueryVariables,
} from '#src/graphql/generated';
import type { TypedDocumentNode } from '@apollo/client';

import { gql } from '@apollo/client';

export const GET_PROCESSOR_INSTANCE: TypedDocumentNode<
  GetProcessorInstanceQuery,
  GetProcessorInstanceQueryVariables
> = gql`
  query GetProcessorInstance($id: String!) {
    processorInstance(id: $id) {
      id
      processorId
      userId
      isActive
      value
      error
      createdAt
      updatedAt
    }
  }
`;
